export default "__VITE_ASSET__Dlo_9zME__"